import {
  Backdrop, Container, Input, Paper
} from '@material-ui/core';
import CircularProgress from '@material-ui/core/CircularProgress';
import SearchIcon from '@material-ui/icons/Search';
import { makeStyles } from '@material-ui/styles';
import React, { useState } from 'react';
import { useTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import Header from 'src/components/Header';
import Page from 'src/components/Page';
import axios from 'src/utils/axios';
import { getUser } from 'src/utils/Common';
import { getTasksRequest } from '../../store/actions/taskActions';
import BultenDetay from './BulletinDetail';
import BottomRouters from 'src/components/BottomRouters';

const useStyles = makeStyles((theme) => ({
  root: {
    paddingTop: theme.spacing(3),
    paddingBottom: theme.spacing(3)
  },
  BultenDetay: {
    marginTop: theme.spacing(1)
  },
  searchB: {
    flexGrow: 1,
    height: 42,
    padding: theme.spacing(0, 2),
    display: 'flex',
    alignItems: 'center'
  },
  searchIconB: {
    marginRight: theme.spacing(0),
    color: theme.palette.icon
  },
  searchInputB: {
    flexGrow: 1
  },
  searchButtonB: {
    backgroundColor: theme.palette.common.white,
    marginLeft: theme.spacing(2)
  },
  backdrop: {
    zIndex: theme.zIndex.drawer + 1,
    color: '#fff',
  },
}));


const Bulten = (props) => {
  const classes = useStyles();
  const { t } = useTranslation('bulletin');
  const [BultenData, setBultenData] = useState([]);
  const SessionUser = getUser();
  const [Loading, setLoading] = useState(false);
  const [filter, setFilter] = useState('0');

  const BultenIcerikAra = () => {
    setLoading(true);
    axios.get(`/GetSiriusBulletin/2/${SessionUser.ServiceShopId}/${SessionUser.UserId}/${filter}`).then((response) => {
      const Deger = response.data;
      setBultenData(Deger);
      setLoading(false);
    }).catch((error) => {
      setLoading(false);
    });
  };


  return (
    <Page className={classes.root} title={'Sirius Tech'}>
      <Container maxWidth="lg">
        <Header />
        {
          Loading
            ? (
              <Backdrop className={classes.backdrop} open={Loading}>
                <CircularProgress color="inherit" />
              </Backdrop>
            )
            : <div />
        }
        <Paper
          className={classes.searchB}
          elevation={1}
        >
          <Input
            className={classes.searchInputB}
            disableUnderline
            onChange={(event) => { setFilter(event.target.value); }}
            placeholder={t('search')}
          />
          <SearchIcon onClick={BultenIcerikAra} className={classes.searchIconB} />
        </Paper>
        <BultenDetay className={classes.BultenDetay} BultenDetay={BultenData} loading={Loading} setLoading={setLoading} />
      </Container>
        <BottomRouters/>
    </Page>
  );
};


export default connect(
  (state) => ({ tasks: state.tasks1 }),
  {
    getTasksRequest
  }
)(Bulten);
